<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">免费产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">免费云服务器</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">免费云服务器</div>
      </div>
      <div class="freevps-header ub-box">
        <div class="header-left ub-box ub-ver ub-ver-v">
          <div class="header-left-icon"></div>
        </div>
        <div class="header-right">
          <p>优点：永久免费、在线一键开通、BGP多线路云服务器，送免备案服务。</p>
          <p>缺点：免费云服务器相比收费云服务器稳定性欠佳，售后服务响应时间长。
            <a class="z-color-a" target="_blank" href="/free">了解更多产品详情></a>
          </p>
          <el-button v-if="num === 0" type="primary" @click="vpsInit" class="z-margin-top-20-precent">立即开通</el-button>
          <div v-if="num === 0" class="alert-deng" style="display: inline-block;margin-left: 15px;">
            开通必读：免费云服务器禁止做黑客扫描、抓鸡等任何违法信息，发现即永久关停并上报公安机关...
            <a href="/help/content_1112.html" class="z-color-a" target="_blank">查看详情</a>
          </div>
          <el-button v-if="num === 1 && vpsList.Pstate != '未初始化'" type="primary" class="z-margin-top-20-precent" @click="Manage">管理面板</el-button>
        </div>
      </div>
      <div class="panel-body clearfix">
        <div style="padding: 30px 108px 0 0;" v-if="num === 0">
          <div class="Z-hr"></div>
          <div class="z-margin-top-20-precent goodness">
            <div class="se-panel-title ub-box">
              免费云服务器优势：
            </div>
            <el-row class="z-margin-top-10-precent">
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-01"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">配置齐全</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">CPU1核、内存1G、带宽1M</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">永久免费使用、开通简单快捷</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-02"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">高质量BGP线路</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">使用优秀的国内BGP线路，速度快</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">具备高在线率、高安全性、高稳定性</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-03"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">免备案服务</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">无偿使用免备案服务</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">没有备案的域名也可以使用</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content">
                  <div class="ub-box ub-ver-h z-margin-top-30-precent">
                    <div class="goodness-icon icon-04"></div>
                  </div>
                  <div class="ub-box ub-ver-h z-margin-v-20-precent">
                    <h4 class="z-font-size-16 z-color-h4">十八年行业经验</h4>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">拥有十八年的行业经验</p>
                  </div>
                  <div class="ub-box ub-ver-h">
                    <p class="z-lineHeight-20 z-color-muted">创始团队在云服务器行业遨游十八年</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-if="num === 1">
          <div class="freevps-table">
            <el-row type="flex" align="middle" class="row-border" style="border-top: 1px solid #eee;">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700">IP地址 :</div></el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content z-padding-left-25-precent">
                  <span v-if="vpsList.Pstate != '未初始化'">{{vpsList.ip}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700">操作系统 :</div></el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content z-padding-left-25-precent">
                  {{vpsList.OsType}}
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3">
                <div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700" style="line-height: 70px;">服务器配置 :</div>
              </el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content-small z-padding-left-25-precent">
                  <el-row>
                    <el-col :span="6">实例：<span class="z-color-green z-font-weight-700">{{vpsList.cpu}}核/{{vpsList.ram}}G</span></el-col>
                    <el-col :span="6">硬盘：<span class="z-color-green z-font-weight-700">{{vpsList.disk}}G</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">带宽：<span class="z-color-green z-font-weight-700">{{vpsList.net}}M</span></el-col>
                    <el-col :span="6">线路：<span class="z-color-green z-font-weight-700">{{vpsList.xianlu}}</span></el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700">服务器状态 :</div></el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content z-padding-left-25-precent">
                  <i v-if="!vpsList.state" class="el-icon-loading"></i>
                  <span v-if="vpsList.state">
                  <span v-if="vpsList.state.loading != 'ok' && vpsList.state.msg" class="z-color-green-state state-icon" :class="{'server-state-run':vpsList.state.msg.indexOf('运行') != -1,'server-state-stop':vpsList.state.msg.indexOf('关机') != -1}">{{vpsList.state.msg}}</span>
                  <i v-if="vpsList.state.loading === 'ok'" class="el-icon-loading z-font-size-16"></i>
                  <span v-if="vpsList.state.loading === 'ok'" class="z-color-red">{{vpsList.state.loading_txt}}</span>
                 （{{vpsList.state.Pstate}}）
                </span>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3"><div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700">开通时间 :</div></el-col>
              <el-col :sm="18" :md="20" :lg="21">
                <div class="grid-content z-padding-left-25-precent">
                  {{vpsList.StartTime}}
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="row-border">
              <el-col :sm="6" :md="4" :lg="3">
                <div class="grid-content grid-content-left z-textAlign-center z-color-636 z-font-weight-700 z-font-size-13" style="line-height: 60px;">到期时间 :</div></el-col>
              <el-col :xs="8" :sm="8" :md="8" :lg="6">
                <div class="grid-content z-padding-left-25-precent" style="line-height: 30px;">
                  <el-row>
                    <el-col>{{vpsList.EndTime}}</el-col>
                    <el-col class="z-color-red">剩余{{vpsList.left_time}}</el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :xs="10" :sm="10" :md="12" :lg="{span:15,pull:2}">
                <div class="grid-content" style="line-height: 60px;margin-left: 10px;">
                  <el-button v-if="vpsList.Pstate != '未初始化'" type="primary" @click="Delay">免费延期</el-button>
                  <div class="alert-deng" style="display: inline-block;margin-left: 15px;width: 380px;">
                    首次开通24小时，开通6小时后可免费申请延期，每次最长延期5天。
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="freevps-help">
            <div class="se-panel-title ub-box">
              相关帮助：
            </div>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index<2">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>1 && index<4">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>3 && index<6">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="120">
              <el-col :span="12" v-for="(item,index) in gonggaoList" :key="item.id" v-if="item.title && index>5 && index<8">
                <div class="notice-list-panel ub-box">
                  <ul class="z-width-100-precent">
                    <li class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                      <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
        <!--blackpink-->
        <div v-if="dialogShadow" class="dialogShadow"></div>
        <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
          <dd class="dialogTitle z-font-size-16">
            <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
            <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
          </dd>
          <dd class="dialogContent z-color-666 z-font-size-15 ">
            <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
            <span v-if="info == 'wx_no_bind'" class="z-font-size-15" >您的帐户还没有绑定微信</span>
            <span v-if="info == 'smrz_fail'" class="z-font-size-15" >您的帐户还没有实名认证</span>
            <br>
            <router-link v-if="info == 'wx_no_bind'" to="/weixin" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里绑定微信</router-link>
            <router-link v-if="info == 'smrz_fail'" to="/auth" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里实名认证</router-link>
          </dd>
          <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
            <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
            <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import helpService from 'business/helpService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        num:Number,
        listLoading:false,
        dialogLoading:false,
        dialogShadow:false,
        vpsList:[],
        gonggaoList: [],
        count:10,
        total:0,
        page:1,
        info:''
      }
    },
    components:{
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    /*created() {
      this.timer = setInterval(() => {
        this.getTime()
      }, 1000)
    },*/
    mounted() {
      this.VpsQuery()
      this.getGonggao()
    },
    /*beforeDestroy() {
      if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断
        clearInterval(this.timer); //关闭
      }
    },*/
    methods:{
      ...mapActions(['DELAY']),
      async VpsQuery() {
        this.listLoading = true
        let data = 'cmd=vps_list' + '&vps_type=free'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.num = vueData.msg.content.length
          let content = vueData.msg.content[0]
          if(this.num>0){
            this.vpsList = {
              show:false,
              id:content.id,
              Pstate:content.Pstate,
              ip:content.ip,
              OsType:content.OsType,
              cpu:content.CPU,
              ram:content.RAM,
              disk:content.SSD,
              net:content.NET_WIDTH,
              xianlu:content.NET_TYPE,
              StartTime:content.StartTime,
              EndTime:content.EndTime,
              left_time:content.left_time,
              state:this.VpsState(content.id) ? false : false,
            }
          }
          this.listLoading = false
        }else {
          this.listLoading = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      async getGonggao() {
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST','cmd=query&type_id=266')
        if(vueData.response==200){
          this.gonggaoList = vueData.msg.content
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async getTime() {
        let data = 'cmd=vps_list' + '&vps_type=free'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.vpsList.left_time = vueData.msg.content[0].left_time
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async vpsInit() {
        this.dialogLoading = true
        let data = 'cmd=free_vps_init'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.VpsQuery()}})
        }else {
          this.dialogLoading = false
          if(vueData.msg === 'wx_no_bind' || vueData.msg === 'smrz_fail'){
            this.info = vueData.msg
            this.dialogShadow = true
          }else {
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      async VpsState(id) {
        let data = 'cmd=get_vps_state'+
          '&id='+ id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          /*this.vpsList.map((item, index) => {
            if(id == item.id){
              item.state = vueData
            }
          })*/
          this.vpsList.state = vueData
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      Manage() {
        this.DELAY('first')
        this.$router.push('/freeServer/'+ this.vpsList.id)
      },
      Delay() {
        this.DELAY('seven')
        this.$router.push('/freeServer/'+ this.vpsList.id)
      },
      clickBtn() {
        this.dialogShadow = false
      }
    }
  }
</script>

<style scoped>
  .hideleft { margin-left: 80px; }
  .freevps-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 10px;
  }
  /*.page-main {
    min-height: calc(100vh - 150px);
  }*/
  .header-left {
    height: 96px;
    width: 96px;
    background-color: #00AAFF;
  }
  .header-left-icon {
    width: 63px;
    height: 60px;
    background: url(../../assets/imgs/freevps.png) no-repeat;
  }
  .header-right {
    padding-left: 20px;
  }
  .header-right p {
    color: #A0A2A3;
    line-height: 20px;
  }
  .se-panel-title {
    font-size: 16px;
  }
  .goodness {
    margin-bottom: 50px;
  }
  .goodness .grid-content {
    min-height: 224px;
    border: 1px solid #eee;
    border-right: 0;
  }
  .goodness .el-row:last-child {
    border-right: 1px solid #eee;
  }
  .goodness-icon {
    width: 69px;
    height: 53px;

  }
  .icon-01 {
    background: url(../../assets/imgs/goodness_01.png) no-repeat;
  }
  .icon-02 {
    background: url(../../assets/imgs/goodness_02.png) no-repeat;
  }
  .icon-03 {
    background: url(../../assets/imgs/goodness_03.png) no-repeat;
  }
  .icon-04 {
    background: url(../../assets/imgs/goodness_04.png) no-repeat;
  }
  .freevps-help {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #eee;
    margin-bottom: 20px;
  }
  .notice-list-panel {
    padding: 5px 18px;
  }
  .notice-list-panel li:first-child {
    border-top: none;
  }
  .notice-list-panel li {
    line-height: 3.3rem;
    border-top: 1px dashed #eee;
  }
  .row-border { border-bottom: 1px solid #eee; }
  .freevps-table {
    border-right: 1px solid #eee;
  }
  .freevps-table .grid-content {
    line-height: 40px;
  }
  .freevps-table .grid-content-left {
    background-color: #f7f9fb;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }
  .grid-content-small {
    line-height: 35px;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/freeServerList.vue